import is from '@sindresorhus/is';
import type { ChangeEvent, FunctionComponent } from 'react';
import { Fragment } from 'react';
import Maybe from 'true-myth/maybe';

import { PrimaryButton } from './components/PrimaryButton';
import { StepHeader } from './components/StepHeader';
import { TextArea } from './components/TextArea';
import { useCompanyOnboardingStore } from './use-company-onboarding-store';

export const CompanyPrioritiesStep: FunctionComponent = () => {
    const companyPriorities = useCompanyOnboardingStore((state) => state.companyPriorities);
    const isGeneratingCompanyPriorities = useCompanyOnboardingStore((state) => state.isGeneratingCompanyPriorities);
    const setCompanyPriorities = useCompanyOnboardingStore((state) => state.setCompanyPriorities);
    const updateCompanyProfile = useCompanyOnboardingStore((state) => state.updateCompanyProfile);

    const handleChange = (event: ChangeEvent<HTMLTextAreaElement>): void => {
        const data: Maybe<string> = is.emptyString(event.target.value)
            ? Maybe.nothing()
            : Maybe.just(event.target.value);
        setCompanyPriorities(data);
    };

    const continueLabel = useCompanyOnboardingStore((state) => state.continueLabel);
    const companyPrioritiesTitle = useCompanyOnboardingStore((state) => state.companyPrioritiesTitle);
    const companyPrioritiesSubTitle = useCompanyOnboardingStore((state) => state.companyPrioritiesSubTitle);
    const descriptionLabel = useCompanyOnboardingStore((state) => state.descriptionLabel);

    return (
        <Fragment>
            <StepHeader headlineText={companyPrioritiesTitle} subHeadlineText={companyPrioritiesSubTitle} />
            <TextArea
                isGenerating={isGeneratingCompanyPriorities}
                text={companyPriorities.unwrapOr('')}
                title={descriptionLabel}
                onChange={handleChange}
            />
            {isGeneratingCompanyPriorities ? null : (
                <PrimaryButton disabled={companyPriorities.isNothing} onClick={updateCompanyProfile}>
                    {continueLabel}
                </PrimaryButton>
            )}
        </Fragment>
    );
};
